module.exports = __webpack_public_path__ + "static/media/Austria.98b4c366.png";